import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';
import { Organizations } from './model';
import { OrganizationsView } from './view';
import { AppWrapper } from '../appwrapper/model';
import { AppWrapperView } from '../appwrapper/view';
import { NavbarTab } from '../navbar/view';

export const OrganizationsRoute = (model : Organizations, appWrapper : AppWrapper) : IRoute => ({
    view:
        <AppWrapperView model={appWrapper} navbarTab={NavbarTab.Everyone}>
            <OrganizationsView model={model} />
        </AppWrapperView>
});


// WEBPACK FOOTER //
// ./apps/portcall/organizations/route.tsx